import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { BancoAccessGuard } from '../../guard/auth-guard/banco-access.guard';

export const bancoRoutes: Routes = [
  {
    path: 'banco',
    canActivate: [AuthGuard, BancoAccessGuard],
    data: {
      title: 'Dados Bancários',
      breadcrumb: [{ label: 'Dados Bancários', url: '/banco' }],
    },
    loadComponent: () =>
      import('./banco.component').then((m) => m.BancoComponent),
  },
];
